import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setModalsData, TModalsState } from "../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { AdminFormFieldSubmit } from "../../components/admin/formFields";

type ModalDeleteDomainProps = {
  onDeleteConfirm: () => void;
};

const ModalDeleteDomain: FC<ModalDeleteDomainProps> = ({ onDeleteConfirm }) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix: "whiteLabeling.deleteModal",
  });
  const [isChecked, setIsChecked] = useState(false);
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );

  useEffect(() => {
    if (modalsState.showDeleteDomainModal) {
      setIsChecked(false);
    }
  }, [modalsState.showDeleteDomainModal]);
  const dispatch = useDispatch();
  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showDeleteDomainModal: false }));
  };

  const handleSubmit = () => {
    hideModal();
    onDeleteConfirm();
  };

  if (modalsState.showDeleteDomainModal === false) return null;
  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      ></div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none z-modal">
        <div className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-[480px] z-modal">
          <form
            className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl"
            onSubmit={handleSubmit}
          >
            <h2 className="col-span-6 text-3xl font-bold text-heading-black">
              {t("heading")}
            </h2>
            <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
              {t("sub_heading")}
            </p>
            <AdminFormFieldSubmit
              label={t("confirm_button")}
              type="button"
              variant="danger"
              onClick={handleSubmit}
            />

            <AdminFormFieldSubmit
              label={tMain("cancel")}
              type="button"
              variant="primary-like"
              onClick={hideModal}
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default ModalDeleteDomain;
